import AssignmentIndIcon from '@mui/icons-material/AssignmentInd';
import EditIcon from '@mui/icons-material/Edit';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import SettingsIcon from '@mui/icons-material/Settings';
import ViewModuleIcon from '@mui/icons-material/ViewModule';
import WorkspacePremiumIcon from '@mui/icons-material/WorkspacePremium';
import { IconButton, Menu, MenuItem } from '@mui/material';
import { alpha, styled } from '@mui/material/styles';
import * as React from 'react';
// import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import DeleteIcon from '@mui/icons-material/Delete';
import DetailsIcon from '@mui/icons-material/Details';
import PublishedWithChangesIcon from '@mui/icons-material/PublishedWithChanges';
import SensorDoorIcon from '@mui/icons-material/SensorDoor';
import { RED_COLOR } from '../constants/ColorsConst';
import { SimpleLineIconsCalculator } from './icons/calculator';

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color:
      theme.palette.mode === 'light'
        ? 'rgb(55, 65, 81)'
        : theme.palette.grey[500],
    boxShadow:
      'rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px',
    '& .MuiMenu-list': {
      padding: '4px 0',
    },
    '& .MuiMenuItem-root': {
      '& .MuiSvgIcon-root': {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
      },
      '&:active': {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity,
        ),
      },
    },
  },
}));

const ActionsListWidget = ({
  id,
  onEdit,
  onDetalles,
  onSuscripcion,
  onAdministrador,
  onVistas,
  onAjustes,
  onDelete,
  onActivar,
  onEstatus,
  onBloquear,
  onAsignarModulos,
  onCalcularNota,
  activo,
}) => {
  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  const detallesComponent = onDetalles && (
    <MenuItem
      key={`${id}detalles`}
      onClick={() => {
        onDetalles();
        setAnchorEl(null);
      }}
      disableRipple
    >
      <DetailsIcon />
      Detalles
    </MenuItem>
  );

  const editComponent = onEdit && (
    <MenuItem
      key={`${id}edit`}
      onClick={() => {
        onEdit();
        setAnchorEl(null);
      }}
      disableRipple
    >
      <EditIcon />
      Editar
    </MenuItem>
  );

  const suscripcionComponent = onSuscripcion && (
    <MenuItem
      key={`${id}suscription`}
      onClick={() => {
        onSuscripcion();
        setAnchorEl(null);
      }}
      disableRipple
    >
      <WorkspacePremiumIcon />
      Suscripción
    </MenuItem>
  );

  const administradorComponent = onAdministrador && (
    <MenuItem
      key={`${id}administrator`}
      onClick={() => {
        onAdministrador();
        setAnchorEl(null);
      }}
      disableRipple
    >
      <AssignmentIndIcon />
      Administrador
    </MenuItem>
  );

  const vistasComponent = onVistas && (
    <MenuItem
      key={`${id}vistas`}
      onClick={() => {
        onVistas();
        setAnchorEl(null);
      }}
      disableRipple
    >
      <ViewModuleIcon />
      Vistas
    </MenuItem>
  );

  const deleteComponent = onDelete && (
    <MenuItem
      key={`${id}delete`}
      onClick={() => {
        onDelete();
        setAnchorEl(null);
      }}
      disableRipple
      sx={{ color: RED_COLOR }}
    >
      <DeleteIcon sx={{ color: `${RED_COLOR} !important` }} />
      Eliminar
    </MenuItem>
  );

  const activarComponent = onActivar && (
    <MenuItem
      key={`${id}activar`}
      onClick={() => {
        onActivar();
        setAnchorEl(null);
      }}
      disableRipple
    >
      <SensorDoorIcon />
      Activar
    </MenuItem>
  );

  const bloquearComponent = onBloquear && (
    <MenuItem
      key={`${id}bloquear`}
      onClick={() => {
        onBloquear();
        setAnchorEl(null);
      }}
      disableRipple
    >
      <SensorDoorIcon />
      Bloquear
    </MenuItem>
  );

  const asignarModulosComponent = onAsignarModulos && (
    <MenuItem
      key={`${id}asignarModulos`}
      onClick={() => {
        onAsignarModulos();
        setAnchorEl(null);
      }}
      disableRipple
    >
      <ViewModuleIcon />
      Asignar Módulos
    </MenuItem>
  );

  const ajustesComponent = onAjustes && (
    <MenuItem
      key={`${id}ajustes`}
      onClick={() => {
        onAjustes();
        setAnchorEl(null);
      }}
      disableRipple
    >
      <SettingsIcon />
      Ajustes
    </MenuItem>
  );
  const estatusComponent = onEstatus && (
    <MenuItem
      key={`${id}estatus`}
      onClick={() => {
        onEstatus();
        setAnchorEl(null);
      }}
      disableRipple
    >
      <PublishedWithChangesIcon />
      Cambiar estatus
    </MenuItem>
  );
  const calcularNotaComponent = onCalcularNota && (
    <MenuItem
      key={`${id}calcular`}
      onClick={() => {
        onCalcularNota();
        setAnchorEl(null);
      }}
      disableRipple
    >
      <SimpleLineIconsCalculator size={25} />
      Calcular nota
    </MenuItem>
  );

  const menus = [
    editComponent,
    detallesComponent,
    suscripcionComponent,
    administradorComponent,
    vistasComponent,
    asignarModulosComponent,
    ajustesComponent,
    estatusComponent,
    activarComponent,
    bloquearComponent,
    deleteComponent,
    calcularNotaComponent,
  ];

  return (
    <div>
      <IconButton
        aria-label="more"
        id={`${id}icon`}
        aria-controls={open ? 'long-menu' : undefined}
        aria-expanded={open ? 'true' : undefined}
        aria-haspopup="true"
        size="small"
        onClick={handleClick}
      >
        <MoreVertIcon sx={{ color: `${activo ? 'white' : 'balck'}` }} />
      </IconButton>
      <StyledMenu
        id={`${id}styled`}
        MenuListProps={{
          'aria-labelledby': id,
        }}
        anchorEl={anchorEl}
        open={open}
        onClose={handleClose}
      >
        {menus.map((e) => e)}
      </StyledMenu>
    </div>
  );
};

export default ActionsListWidget;
